<template>
    <div id="ComponentInventoryRSBList">
        <div class="loader" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <template v-if="!showBarcode">
                    <div class="page-name">
                        <div class="page-title"> {{pageTitle}}</div>
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                              <i class="fp-export"></i> Export
                            </a>
                            <router-link title="Back" class="btn btn-secondary" v-bind:to="{name: 'ComponentInventoryList'}"><i class="fp-back"> </i>Back </router-link>
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="admin-page-content component-inventory-list">
                            <data-table-filter-config :moduleName="'ComponentInventoryRSBList'" ref="filterComponentInventory" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                          <section class="data-table bg-white">
                            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                                    <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'ComponentInventoryRSBList'" :position="'top'">
                                    </custom-pagination>
                                    <vue-good-table
                                        ref="listComponentInventoryTable"
                                        mode="remote"
                                        title="Part Transaction"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                        enabled: component_value,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                        enabled: false,
                                        }">
                                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                            <div :key="key">
                                                <div v-if="props.column.field == 'action'">
                                                    <router-link title="Edit Part Inventory" v-if="canUpdateCom" class="fp-edit" v-bind:to="{name: 'ComponentInventoryEdit',params:{id:props.row.id}}"></router-link>
                                                    <span>&nbsp;|&nbsp;</span>
                                                    <router-link title="List Part Transaction" v-if="canUpdateCom" class="fp-view" v-bind:to="{name: 'ComponentTransactionList',params:{id:props.row.id}}"></router-link>
                                                </div>
                                                <div v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </div>
                                            </div>
                                        </template>
                                        <div slot="selected-row-actions">
                                        <button v-if="component_value" id="deleteComponentInventoryBtn" v-on:click.prevent="ItemDelete()" class="btn btn-danger">Delete</button>
                                    </div>
                                    </vue-good-table>
                                    <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                    </custom-pagination>
                            </section>
                            <div class="modal fade invpart-upload-modal" id="invpart-upload-modal" ref="invpart-upload-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="invpart-upload-modal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Select File</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="importIFTAFile" class="addinspectionForm">
                                                <div class="form-row">
                                                    <div class="col form-group">
                                                        <label class="control-label require mb-2" for="name">File:</label><br/>
                                                        <input id="invpartUploadFile" type="file" @change="onFileChanged">
                                                        <div class="field-error">{{import_error}}</div>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col form-group" v-if="fileName != ''">
                                                        <label class="control-label"> Download Sample file </label>
                                                        <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                    </div>
                                                </div>

                                                <p v-if="importedCount > 0"><i class="fa fa-check" aria-hidden="true"></i> &nbsp;<strong>{{importedCount}} Records imported</strong></p> 

                                                <template v-if="duplicatePart.part != undefined">
                                                    <ul>
                                                        <li v-for="(item, key) in duplicatePart.part" :key="key">
                                                            <p><strong>{{ key }} </strong> Part Not Imported</p>
                                                            <ul>
                                                            <li v-for="(value, prop) in item" :key="prop">
                                                                <template v-if="value == ''">
                                                                    <span v-if="prop == 'part_number'">Part Is Blank</span> 
                                                                    <span v-if="prop == 'location_code'">Location Is Blank</span> 
                                                                    <span v-if="prop == 'warehouse_code'">Warehouse Is Blank</span> 
                                                                    <span v-if="prop == 'warehouse_bin_mapper_id'">Warehouse Bin Mapper Not Mapped For {{value}} Part</span> 
                                                                </template>
                                                                <template v-else> 
                                                                    <span v-if="prop == 'part_number'">Part {{ value }} Not Available</span>
                                                                    <span v-if="prop == 'location_code'">Location {{ value }} Not Available</span>
                                                                    <span v-if="prop == 'warehouse_code'">Warehouse {{ value }} Not Available</span>
                                                                    <span v-if="prop == 'warehouse_bin_mapper_id'">Warehouse Bin Mapper Not Mapped For {{value}} Part</span>
                                                                </template>
                                                            </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </template>
                                                <!--
                                                <p v-if="duplicatePart.part != undefined || duplicatePart.manufacturer != undefined || duplicatePart.categories != undefined
                                                    || duplicatePart.location != undefined || duplicatePart.warehouse != undefined">&nbsp;</p>
                                                <template v-if="duplicatePart.part && duplicatePart.part.length > 0">
                                                    <label class="d-block"> Part Not Imported Because These Part Not Available:</label>
                                                    <template v-for="(part,partKey) in duplicatePart.part">
                                                        <a :key="partKey" v-if="partKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="partKey">{{part.part_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <template v-if="duplicatePart.manufacturer && duplicatePart.manufacturer.length > 0">
                                                    <label class="d-block"> Part Not Imported Because Manufacturer For These Part Not Available:</label>
                                                    <template v-for="(part,partKey) in duplicatePart.manufacturer">
                                                        <a :key="partKey" v-if="partKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="partKey">{{part.part_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <template v-if="duplicatePart.categories && duplicatePart.categories.length > 0">
                                                    <label class="d-block"> Part Not Imported Because Category For These Part Not Available:</label>
                                                    <template v-for="(part,partKey) in duplicatePart.categories">
                                                        <a :key="partKey" v-if="partKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="partKey">{{part.part_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <template v-if="duplicatePart.location && duplicatePart.location.length > 0">
                                                    <label class="d-block"> Part Not Imported Because Location For These Part Not Available:</label>
                                                    <template v-for="(part,partKey) in duplicatePart.location">
                                                        <a :key="partKey" v-if="partKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="partKey">{{part.part_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <template v-if="duplicatePart.warehouse && duplicatePart.warehouse.length > 0">
                                                    <label class="d-block"> Part Not Imported Because Warehouse For These Part Not Available:</label>
                                                    <template v-for="(part,partKey) in duplicatePart.warehouse">
                                                        <a :key="partKey" v-if="partKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="partKey">{{part.part_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                -->
                                            </form>

                                            <div class="modal-footer">
                                                <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                                <button class="btn btn-primary" id="importButton" v-on:click="importParts()"> <i class="fp-import"> </i> Import</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <app-component-barcode :selected="selectedRows"></app-component-barcode>
                </template>
                    <!-- <div class="page-name">
                        <div class="page-title"> Barcode List</div>
                        <div class="btn-groups text-right">
                            <button type="button" class="btn btn-secondary" v-on:click="backBtn()" >
                                <i class="fp-back"> </i> Back
                            </button>
                            <button type="button" class="btn btn-primary" v-on:click="print()" >
                                <i class="fp-print"> </i> Print
                            </button>
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="admin-page-content barcode-list">
                            <section class="internal-container border-top-table-fl" id="barcodeList">
                                <template v-if="rows.length > 0">
                                    <template v-for="row in rows">
                                        <div class="" v-if="row.barcode != '' && row.barcode != NULL" :key="'barcode_'+row.id">
                                            <p style="margin-bottom:0">({{ row.vmrsCode }}) {{ row.itemName }}</p>
                                            <img :src="'data:image/png;base64,'+ row.barcode" alt="barcode"/>
                                            <p style="margin-bottom:0">{{ row.mfgCode }}  {{ row.itemCode }}</p>
                                            <p style="margin-bottom:0">R/S/B   {{ row.rsb }}</p>
                                        </div>
                                    </template>
                                </template>
                            </section>
                        </div>
                    </div>
                </template> -->
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";

import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import 'vue-good-table/dist/vue-good-table.css';
import VueGoodTable from 'vue-good-table';
import EventBus from "././event-bus";
Vue.use(VueGoodTable);

import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ComponentInventoryRSBList",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            appComponentBarcode: () => import('@/components/ComponentBarcode'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            clearCacheData: () => import('@/components/ClearCacheData'),
            appFooter: () => import('@/components/Footer'),
        },
        metaInfo() {
            return {title: "Part Inventory List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            hideButton : false,
            pageTitle: "Part Inventory RSB List",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                    filterable: false
                },
                {
                    label: 'Part',
                    field: 'item',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Part", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Part Desc',
                    field: 'itemName',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Part Desc", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Manufacturer',
                    field: 'mfgCode',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Categories',
                    field: 'catCode',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Categories", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warehouse',
                    field: 'warehouse',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Warehouse", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Row',
                    field: 'row',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Shelf',
                    field: 'shelf',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Bin',
                    field: 'bin',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Quantity',
                    field: 'quantity',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Quantity", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Avg Cost',
                    field: 'base_price',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Avg Cost", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            component_value: false,
            loading:false,
            canUpdateCom:false,
            canAddCom:false,
            action:"list",
            showBarcode:false,
            pageKey:"_component_inventory_list_",
            batchProcess:0,
            batchNum:"",
            duplicatePart:[],
            importedCount:0,
            import_error:'',
            fileName:'',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_component_transaction') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_component') {
                          if(self.$route.query.flag == 'inventoryReport'){
                            self.component_value = false;
                          }else{
                            self.component_value = true;
                          }
                        }
                        if (permissions[i].name == 'add_component_transaction') {
                            self.canAddCom = true;
                            self.canUpdateCom = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();

            if(self.$route.query.flag == 'inventoryReport'){
              self.hideButton = true;
              self.pageTitle = "Inventory As At Detail";

              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }         

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listComponentInventoryTable.unselectAllInternal();
            },

            backBtn(){

                this.showBarcode = false;

            },

            print() {
                var self = this;
                self.loading = true;
                var content = document.getElementById('barcodeList').innerHTML;
                var a = window.open(content, '_blank');
                a.document.write(content);
                a.document.close();
                self.loading = false;
                a.print();
                a.close();
            },
            previewBarcode: function() {
                var selectedRows = [];

                //because on first load list not initialize
                var ids = '';
                var data = this.$refs['listComponentInventoryTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listComponentInventoryTable'].selectedRows[i].id)
                    if (ids == ''){
                        ids = this.$refs['listComponentInventoryTable'].selectedRows[i].id;
                    }else{
                        ids += ','+this.$refs['listComponentInventoryTable'].selectedRows[i].id;
                    }
                }

                this.selectedRows = selectedRows;
                // alert(self.selectedRows);return;
                this.showBarcode = true;
                this.action = "previewBarcode";
                // this.loadList();
            },

          selectionChanged(param) {

            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            return;
          },
          exportCheck: function() {
            var self = this;
            var count = 0;
            var actionFlag = "";
            var data = this.$refs['listComponentInventoryTable'].selectedRows;
            count = data.length;

            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }

            this.exportReports(actionFlag);
          },
          transferItem:function(){
            var self = this;

            self.$router.push('/inventory-transfer/list');
          },


            loadList() {
              
                var self = this;
                self.loading = true;
                //get selected customers ids

                var selectedRows = [];

                if ( self.firstLoad == 1 ) {
                    //because on first load list not initialize
                    var data = this.$refs['listComponentInventoryTable'].selectedRows;
                    for ( var i = 0; i < data.length; i++ ) {
                        selectedRows.push(this.$refs['listComponentInventoryTable'].selectedRows[i].id)
                    }
                }
                
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[1] == 'part-inventory-rsb' && segments[2] == 'list' && segments[3] != '') {
                    var id = segments[3];
                } else {
                    var id = 0;
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag,
                    selectedRows:selectedRows,
                    action:self.action,
                    selectedAll:self.serverParams.selectedAll,
                    id:id
                };                
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/component-inventory/list",
                    type: "POST",
                    data: fields,
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        "Access-Control-Allow-Headers":
                            "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                        if ( self.action == "delete" ) {

                            self.action = "list";
                            self.$refs.filterComponentInventory.clearSelectAll();
                            self.loadList();

                        }else if ( self.action == "export" ||  self.action == "export_queue") {

                            if ( data.code == "201" ) {
                            alert(data.message);
                            } else {
                            if ( self.action == "export" ) {
                                self.excel = data.content.web;
                                var save = document.createElement("a");
                                save.href = self.excel;
                                save.download = data.content.web;
                                save.target = "_blank";

                                document.body.appendChild(save);
                                save.click();
                                document.body.removeChild(save);

                            } else {

                                self.batchProcess = 1;
                                self.batchNum = data.content;
                            }
                            }
                            self.action = "list";
                            // self.loadList();

                        } else {

                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;

                        }
                        // var stickyTop = $('.page-name').offset().top;

                        // $(window).scroll(function() {
                        //     var windowTop = $(window).scrollTop();

                        //     if (stickyTop < windowTop) {
                        //         $('.filters-container + .bg-white.data-table').addClass('sticky');
                        //     } else {
                        //         $('.filters-container + .bg-white.data-table').removeClass('sticky');
                        //     }
                        // });
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'component-list')
                    }
                });
            },
            ItemDelete() {
                var data = this.$refs['listComponentInventoryTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listComponentInventoryTable'].selectedRows[i].id)
                    if (data[i].quantity > 0){
                        self.$swal('','Please select item with quantity less than 1','info');
                        return;
                    }
                }

                if (confirm('Are you sure that you want to delete this Component Inventory ?')) {

                    self.action = 'delete';
                    self.loadList();
                    // self.loading = true;
                    // $("#deleteItemBtn").val("Deleting ...");
                    // $.ajax({
                    //     url: process.env.ROOT_API + "/component/delete",
                    //     type: "POST",
                    //     data: 'id=' + use,
                    //     headers: {
                    //         'Accept': 'application/json',
                    //         "Access-Control-Allow-Origin": '*',
                    //         "Authorization": "Bearer " + localStorage.getItem("tkn"),
                    //         'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    //         "Cache-Control": "no-cache"
                    //     },
                    //     dataType: 'json',
                    //     success: function (data) {
                    //         self.loading = false;
                    //         setTimeout(function () {
                    //         $(".alert-success").removeClass("show");
                    //             $(".alert-success").addClass("hide");
                    //         }, 10000);
                    //         setTimeout(function () {
                    //             $("#deleteItemBtn").val("Delete");
                    //         }, 10000);
                    //         self.rows = data.content.row;
                    //         if (data.code == '200') {
                    //             self.rows = data.content.row;
                    //             self.totalRecords = data.content.totalRecords;
                    //             self.loadList();
                    //         }
                    //     },
                    //     error: function (jqXHR, exception) {
                    //         self.loading = false;
                    //         self.generateStatusCodeMessage(jqXHR,true,'component-delete')
                    //     }
                    // });
                }
            },
            openModal: function(){
                var self = this;
                self.duplicatePart = [];
                self.importedCount = 0;
                self.selectedFile = "";
                $("#invpartUploadFile").val('');
                self.import_error = '';
                self.generateExcelSample();
                $('#invpart-upload-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                var self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            generateExcelSample() {
                var self = this;
                $.ajax({
                    url:
                    process.env.ROOT_API + "/component-inventory-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: {
                    'Accept': "application/json",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': "Bearer " + localStorage.getItem("tkn"),
                    "Access-Control-Allow-Headers":
                        "Origin, Content-Type, Authorization,X-Requested-With",
                    "Cache-Control": "no-cache"
                    },
                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'ifta-upload-generate')

                    }
                });
            },
            downloadSample(){
                var self = this;
                // alert(self.file);
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importParts() {
                var self = this;
                self.import_error = "";
                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                var fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/component-inventory-excel/import",
                    type: "POST",
                    data: formData,
                    headers: {
                        "Accept": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + localStorage.getItem("tkn"),
                        "Access-Control-Allow-Headers":
                            "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 201) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {

                            if ( Object.keys(data.duplicate).length > 0){

                                self.duplicatePart = data.duplicate;
                                self.importedCount = data.content;

                            }else{
                                if(data.content != false){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#invpart-upload-modal').modal('hide');
                                self.loadList();
                            }

                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'ifta-upload-import-error')
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ComponentInventoryRSBList.vue